<script setup>
import { ref, reactive, computed, onMounted } from "vue"
import moment from 'moment'
import HideColumnsButton from '@/Shared/AGGrid/HideColumnsButton'
import ExportCSVButton from '@/Shared/AGGrid/ExportCSVButton'

const props = defineProps({
    items: {
        type: Array,
        default: () => ([]),
    },
	columnDefs: {
		type: Array,
		default: () => ([
			{ 
				field: "name_publication",
				headerName: "Organisation",
				flex: 6,
				hide: false,
			},
			{ 
				field: "name",
				headerName: "Contact",
				flex: 6,
				hide: false,
			},
			{
				field: "contact_representative_email",
				headerName: "Contact Email",
				flex: 8,
				hide: false,
			},
			{ 
				field: "status",
				flex: 6,
				hide: false,
			},
		]),
	},
});

const emit = defineEmits({
    'item-clicked': {
        type: Object,
        default: () => ({}),
    },
});

function rowClicked(event){
	emit('item-clicked', event.data)
}

const rowData = ref(props.items);

const defaultColDef = {
	sortable: true,
	filter: true,
	flex: 1,
	dataTestid: 'column',
	resizable: true,
};


function clickedGrid(event){
	savePageNumber()
}

function savePageNumber(event){
	if(gridApi.value) {
		localStorage.setItem('memberhip-applications-list-cur-page', gridApi.value.paginationGetCurrentPage())
	}
}

const localColumnDefs = reactive(props.columnDefs)
function toggleColumn(data){
	var col = localColumnDefs.find(x => x.field == data.field)
	col.hide = data.hide
}

const gridApi = ref(null)
function onGridReady(params) {
	gridApi.value = params.api
}

function onFirstDataRendered(params) {
	if(localStorage.getItem('memberhip-applications-list-cur-page')){
		gridApi.value.paginationGoToPage(parseInt(localStorage.getItem('memberhip-applications-list-cur-page')))
	}
}

// we want to be able to disable pagination if the user checks the "show all" box
const enablePagination = ref(true)
const perPage = computed(() => {
	return enablePagination.value ? 10 : props.items.length +1
})
function togglePagination(){
	enablePagination.value = !enablePagination.value
	gridApi.value.paginationSetPageSize(perPage.value)
}
const gridClasses = computed(() => {
	return enablePagination.value ? '' : 'hide-pagination'
})

</script>

<template>
    <div class="flex flex-col h-full grow">
		<ag-grid-vue
			class="ag-theme-alpine"
			:class="gridClasses"
			domLayout='autoHeight'
			:rowHeight="48"
			rowClass="membership-application-list-row"
			:columnDefs="localColumnDefs"
			:rowData="rowData"
			:defaultColDef="defaultColDef"
			rowSelection="none"
			animateRows="true"
			@cell-clicked="rowClicked"
			:pagination="enablePagination"
			:paginationPageSize="perPage"
			@grid-ready="onGridReady"
			@click="clickedGrid"
			@first-data-rendered="onFirstDataRendered"
		>
 		</ag-grid-vue>
    </div>
		
	<div class="w-full flex justify-end pr-4 pt-1">
		<HideColumnsButton
			:columnDefs="localColumnDefs"
			@toggle-column="toggleColumn"
		/>

		<ExportCSVButton
			:grid-api="gridApi"
		/>

		<Button
			class="mb-4 ml-1 text-xs py-1 px-2 self-end"
			color="light-grey"
			@click="togglePagination"
		>
			Show {{enablePagination ? 'All' : 'Pages'}}
		</Button>
			
	</div>
</template>

<style>
.membership-application-list-row .ag-cell {
	cursor: pointer;
	display: flex;
	align-items: center;
}
</style>